module.exports = __webpack_public_path__ + "img/affliction.d637931f.jpg";